import { injectReducer } from 'store/reducers'
import { injectSagas } from 'store/sagas'

export default (store) => ({
  path: 'results',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Results = require('./containers/ResultsContainer').default

      // section off the scope of these constants
      {
        const reducer = require('./modules/reducer').default
        const sagas = require('./modules/sagas').sagas

        /*  Add the reducer to the store on key 'results'  */
        injectReducer(store, {key: 'results', reducer})
        injectSagas(store, {key: 'results', sagas})
      }

      // section off the scope of these constants
      {
        const stateKey = require('containers/LegalFooter/modules/selectors').stateKey
        const reducer = require('containers/LegalFooter/modules/reducer').default
        const sagas = require('containers/LegalFooter/modules/sagas').sagas
        injectReducer(store, {key: stateKey, reducer})
        injectSagas(store, {key: stateKey, sagas})
      }

      /*  Return getComponent   */
      cb(null, Results)

    /* Webpack named bundle   */
    }, 'Results')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/Results/index.js
 **/